<bn-loading-overlay></bn-loading-overlay>

<h5>Taxa de Juros Média</h5>

<div class="container">
  <form  [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
		<div class="col">
		  <h3>Filtros de pesquisa</h3>
		</div>

    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

		<div class="col-auto">
		   <button #focusableSubmit type="button" [disabled]="!pesquisaForm.valid"
		   class="btn btn-success no-margin" (keydown.enter)="buscar()" (click)="buscar()">Pesquisar</button>
		</div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId"
          formControlName="agenteFinanceiro">
          <option [ngValue]=null>Todos
          </option>
          <option [ngValue]="agente.cnpj" *ngFor="let agente of agentesFinanceiros">{{agente.nome}}
          </option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled id="agenteFinanceiro" class="form-select"
        [compareWith]="compararPorId" formControlName="agenteFinanceiro">
        <ng-container *ngFor="let agente of agentesFinanceiros">
          <option selected *ngIf="agente?.cnpj == cnpjUsuario">{{ agente.nome }}</option>
        </ng-container>
      </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="tranche">Cesta:</label>
        <select class="form-select" id="tranche" name="tranche" 
        formControlName="ideTranche">
            <option [ngValue]=null></option>
            <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
              {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
          </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="janela">Janela de apuração:</label>
        <select class="form-select" id="janela" name="janela" 
        formControlName="ideJanelaApuracao">
            <option [ngValue]=null>Todas</option>
            <option [ngValue]="janela.id" *ngFor="let janela of janelas">
              {{janela.id}} ({{janela.dataInicioJanela | date: 'dd/MM/yyyy'}} a {{janela.dataFimJanela | date:
                'dd/MM/yyyy'}})</option>
          </select>
      </div>
      <div class="bn-form-group col-md-2">
          <label class="form-label block">Comparar com a taxa máxima:</label>
          <input type="checkbox"  class="form-check-input checkbox-gigante" name="compararComTaxaMaxima" (click)="atualizarCompararComTaxaMaxima()" formControlName="compararComTaxaMaxima" />
      </div>
    </div>

  </form>
</div>

<app-taxa-juros-media-agente-listagem *ngIf="pesquisado" [todasJanelas]="todasJanelas" [agenteFinanceiro]="agenteFinanceiro" [taxas]="taxas" [ideTranche]="ideTranche" [compararComTaxaMaxima]="compararComTaxaMaxima"></app-taxa-juros-media-agente-listagem>
